import api from "./api";
import apiFunctions from "./functions";

/**
 * Trae los datos de todas las provincias de Argentina
 * (Nota) Incluye la ciudad autonoma de Buenos Aires para poder buscar sus partidos en especifico, es decir, hay una provincia de más.
 *
 * @returns {Promise<Object>} Un promise que resuelve en los datos de las provincias de Argentina.
 */
export const getAllProvincias = () => {
    return new Promise((resolve, reject) => {
        const parameters = {
            filters: [
                'max=5000',
                'aplanar=true',
                'campos=estandar',
            ]
        };

        apiFunctions.get(
            api.provincias,
            parameters,
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error)
            }
        );
    });
}

/**
 * Trae los datos de las localidades de Argentina, si se especifica un nombre de provincia se traen las localidades de ella,
 * si no se especifica un nombre (dejar vacio "") se recuperan todas las localidades de Argentina.
 *
 * @param {string} provincia - Nombre de la provincia
 * @returns {Promise<Object>} Un promise que resuelve en los datos de las localidades de la provincia elegida.
 */
export const getLocalidades = (provincia) => {
    return new Promise((resolve, reject) => {
        const parameters = {
            filters: [
                'max=5000',
                'aplanar=true',
                'campos=estandar',
                ...(provincia !== "" ? [`provincia=${provincia}`] : []),  // solo agregar la provincia si no es un string vacío.
                'exacto=true',
            ]
        };

        apiFunctions.get(
            api.localidades,
            parameters,
            (response) => {
                resolve(response);
            },
            (error) => {
                reject(error)
            }
        );
    });
}


// WEBPACK FOOTER //
// ./src/api/georef/calls.js